export default {
    plugins: {
        textRun: '测试',
        customPlugin: '自定义插件',
        create: '创建',
        HowToCreate: '如何创建',
        builtinPlugin: '内置插件',
        contributePlugin: '贡献插件',
        pluginConfig: '插件配置',
        pluginDescription: '插件描述：',
        pluginIntroduction: '插件说明：',
        confirmDelete: '是否确认删除?',
        pluginName: '插件名称',
        PleasePluginName: '请输入插件名称',
        Name: '插件名称',
        Description: '插件描述',
        pluginDescriptionTip: '插件描述用于插件的决策，请尽量清楚地描述插件的使用场景，即在什么情况下执行该插件。',
        PleasePluginDescription: '请输入插件描述。',
        Avatar: '头像',
        requestUrl: '请求地址',
        requestType: '请求类型',
        requestAddress: '请输入请求地址。',
        requestParameters: '请求参数',
        requiredField: '必填',
        isParameterRequired: '发起请求时该参数是否必填',
        parameterName: '参数名',
        PleaseInputParameterName: '请输入参数名',
        parameterType: '参数类型',
        parameterDescription: '描述',
        parameterDescriptionTip: '描述即参数含义，将根据该描述从用户输入中提取参数，例如：参数名为“phone”，描述为“需输入寄件人或收件人的手机号码”',
        PleaseInputParameterDescription: '请输入参数描述。',
        default: '默认',
        defaultTip: '当未从用户输入中提取到该参数时使用的默认值，选填',
        defaultInput: '参数默认值，选填',
        addSubParameter: '新增子参数',
        pleaseInputValue: '请输入value',
        addParameter: '新增参数',
        responseResult: '响应结果',
        responseResultTip: '填写接口响应的字段名和描述，帮助模型更好理解响应数据。可根据实际接口返回数据自动填写。',
        autoFill: '自动填写',
        array: '数组',
        PleaseInputParameter: '请输入参数',
        responseParameters: '响应参数',
        noRequestParameters: '暂无请求参数',
        statusCode: '状态码：',
        reParse: '重新解析',
        parse: '解析',
        debug: '调试',
        noRequestParametersTip: '无请求参数，可直接点击运行',
        run: '运行',
        debugTip: '点击「运行」按钮进行调试，此处可展示接口返回数据',

        prarameterTypeStr: {
            str: '字符串',
            int: '整数',
            float: '浮点数',
            bool: '布尔',
            object: '对象',
            Array: '数组',
        },
        deleteAllNode: '删除此根节点下所有节点，是否确认删除?',
        deleteNode: '删除节点',
        pleaseFillRequestParameters: '请将请求参数填写完整',
        parameterNameRepeat: '参数名重复',
        parameterNameSupport: '参数名仅支持英文字母和下划线"_"',
        pleaseSelectRequestType: '请选择请求类型',
        pleaseInputRequestAddress: '请输入请求地址',
        pleaseInputRequestParameters: '请输入请求参数',
        pleaseFillParameters: '请填写参数',
        validatePar: {
            pleaseInputPluginName: '请输入插件名称',
            pleaseInputPluginDescription: '请输入插件描述',
            pleaseUploadPluginImage: '请上传插件图片',
            pleaseSelectRequestType: '请选择请求类型',
            pleaseInputRequestAddress: '请输入请求地址',
            pleaseInputRequestParameters: '请输入请求参数',
            pleaseFillResponseParameters: '请重新填写返回参数',
        },
        createSuccess: '创建成功',
    },
}